/* global gdAlertify */
import React, { useState } from "react";
import axiosInstance from "../config/axiosConfig";
import { formatMoney } from "../utils/utils";
import GdTable from "./components/GdTable";

const mesActual = () => {
    const hoy = new Date();
    return `${hoy.getFullYear()}-${String(hoy.getMonth() + 1).padStart(2, "0")}`;
};

const ReporteFacturasPendientes = () => {
    const [desde, setDesde] = useState("2026-02");
    const [hasta, setHasta] = useState(mesActual());
    const [resultados, setResultados] = useState([]);
    const [loading, setLoading] = useState(false);
    const [buscado, setBuscado] = useState(false);

    const buscar = async () => {
        if (!desde || !hasta) {
            gdAlertify.notiError("Debe indicar el mes desde y el mes hasta.");
            return;
        }

        setLoading(true);
        setBuscado(true);
        try {
            const response = await axiosInstance.get("/acuerdo-mutuo/cobranza/facturas/pendientes-rango", {
                params: { desde, hasta }
            });
            setResultados(response.data.data || []);
        } catch (error) {
            console.error("Error al buscar facturas pendientes:", error);
            gdAlertify.notiError("Ocurrió un error al cargar el reporte.");
        } finally {
            setLoading(false);
        }
    };

    const columns = [
        { name: "periodo", title: "Periodo", width: 100 },
        { name: "nombre_paciente", title: "Paciente", width: 200 },
        {
            name: "importe_factura",
            title: "Importe factura",
            type: "number",
            render: (row) => <span className="fw-bold">{`$${formatMoney(row.importe_factura)}`}</span>
        },
        { name: "nombre_razon_social", title: "Nombre o razón social para la factura", width: 220 },
        { name: "rut", title: "RUT" },
        { name: "direccion", title: "Dirección", width: 200 },
        { name: "comuna", title: "Comuna" },
        { name: "giro_glosa", title: "Giro / Glosa" },
        { name: "email_factura", title: "Email factura" },
        { name: "emails_envio", title: "Emails de envío", width: 220 },
        { name: "celular", title: "Celular" },
    ];

    return (
        <div className="container-fluid mt-5">
            <div className="card p-4">
                <h3 className="mb-4">Facturas pendientes por periodo</h3>
                <p className="text-muted small">
                    Pacientes con un monto real a facturar (calculado igual que Cobranza Facturas) que todavía no tienen
                    una factura subida para ese mes.
                </p>
                <div className="row g-2 align-items-end mb-4">
                    <div className="col-md-3">
                        <label className="form-label">Desde (mes)</label>
                        <input
                            type="month"
                            className="form-control"
                            value={desde}
                            onChange={(e) => setDesde(e.target.value)}
                        />
                    </div>
                    <div className="col-md-3">
                        <label className="form-label">Hasta (mes)</label>
                        <input
                            type="month"
                            className="form-control"
                            value={hasta}
                            onChange={(e) => setHasta(e.target.value)}
                        />
                    </div>
                    <div className="col-md-3">
                        <button className="btn btn-primary" onClick={buscar} disabled={loading}>
                            {loading ? "Buscando..." : "Buscar"}
                        </button>
                    </div>
                </div>

                {buscado && (
                    <GdTable
                        columns={columns}
                        data={resultados}
                        defaultItemsPerPage={100}
                        itemsPerPageOptions={[5, 10, 25, 50, 100]}
                        initialSort={[0, "asc"]}
                        loading={loading}
                        exportFilename="facturas-pendientes.xlsx"
                    />
                )}
            </div>
        </div>
    );
};

export default ReporteFacturasPendientes;
